function findRate(
  pan: string,
  recipient: string,
  otherRate: number,
  individualRate: number,
  noPanRate: number
): { rate: number; msgTDS: string; msgPAN: string } {
  let rate = 0;
  let msgPAN = '';
  if (pan === 'no') {
    rate = noPanRate;
    msgPAN = `(In case Pan is not available TDS will be applicable at ${noPanRate}%)`;
  } else {
    rate = recipient === 'individual' ? individualRate : otherRate;
  }
  const msgTDS = `will be applicable @ ${individualRate}% for individuals and HUF and ${otherRate}% for others.`;
  return { rate: rate / 100, msgTDS: msgTDS, msgPAN: msgPAN };
}
interface ITDS_FORMULA {
  recipient: string;
  pan: string;
  paymentType: string;
  fees194J: string;
  paymentAmount: number;
}
export const TDS_FORMULA = ({
  recipient,
  pan,
  fees194J,
  paymentType,
  paymentAmount,
}: ITDS_FORMULA) => {
  const paymentAmo = Number(paymentAmount);
  if (paymentAmo < 0 || paymentAmo > 1e12) {
    const res = 0;
    return {
      tds: res,
    };
  }
  let fields;
  let res = 0;
  let threshold = 50000;
  switch (paymentType) {
    case '192A':
      fields = findRate(pan, recipient, 0, 10, 30);
      threshold = 50000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '193':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 10000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194':
    case '194A(other)':
    case '194K':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 5000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194A(banks)':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 40000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194A(senior)':
      fields = findRate(pan, recipient, 0, 10, 20);
      threshold = 50000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194B':
    case '194B(proviso)':
    case '194BB':
      fields = findRate(pan, recipient, 30, 30, 30);
      threshold = 10000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194BA':
    case '194BA(subsection)':
      threshold = -1;
      fields = findRate(pan, recipient, 30, 30, 30);
      res = fields.rate * paymentAmo;
      break;
    case '194C':
      fields = findRate(pan, recipient, 2, 1, 20);
      threshold = 30000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194IC':
    case '194LBA(a)':
    case '194LBA(b)':
    case '194LBA(2)':
    case '196B':
    case '196C':
    case '196DA':
      threshold = -1;
      fields = findRate(pan, recipient, 10, 10, 20);
      res = fields.rate * paymentAmo;
      break;
    case '194D':
      fields = findRate(pan, recipient, 10, 5, 20);
      threshold = 15000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194DA':
      fields = findRate(pan, recipient, 5, 5, 20);
      threshold = 100000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194E':
    case '194F':
    case '196D(section1)':
      threshold = -1;
      fields = findRate(pan, recipient, 20, 20, 20);
      res = fields.rate * paymentAmo;
      break;
    case '194EE':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 2500;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194G':
    case '194H':
      fields = findRate(pan, recipient, 5, 5, 20);
      threshold = 15000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194I':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 240000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194I(a)':
      fields = findRate(pan, recipient, 2, 2, 20);
      threshold = 240000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194IA':
      fields = findRate(pan, recipient, 1, 1, 20);
      threshold = 5000000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194J':
      threshold = 300000;
      if (paymentAmo > threshold) {
        if (fees194J == 'others') fields = findRate(pan, recipient, 10, 10, 20);
        else if (fees194J == 'actualFees')
          fields = findRate(pan, recipient, 2, 2, 20);
        res = (fields?.rate || 0) * paymentAmo;
      }
      break;
    case '194LA':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 250000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194LB':
    case '194LBA(1)':
    case '194LD':
      threshold = -1;
      fields = findRate(pan, recipient, 5, 5, 20);
      res = fields.rate * paymentAmo;
      break;
    case '194N':
      fields = findRate(pan, recipient, 2, 2, 20);
      threshold = 10000000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194NC':
      fields = findRate(pan, recipient, 2, 2, 20);
      threshold = 30000000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194NF':
      fields = findRate(pan, recipient, 5, 5, 20);
      threshold = 10000000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      } else {
        fields = findRate(pan, recipient, 2, 2, 20);
        threshold = 2000000;
        if (paymentAmo > threshold) {
          res = fields.rate * paymentAmo;
        }
      }
      break;
    case '194NFT':
      fields = findRate(pan, recipient, 5, 5, 20);
      threshold = 2000000;
      if (paymentAmo > threshold && paymentAmo < 30000000) {
        res = fields.rate * paymentAmo;
      } else {
        threshold = 30000000;
        if (paymentAmo > threshold) {
          res = fields.rate * paymentAmo;
        }
      }
      break;
    case '194O':
      fields = findRate(pan, recipient, 1, 1, 5);
      if (recipient === 'individual') threshold = 500000;
      res =
        recipient === 'other' || paymentAmo > 500000
          ? fields.rate * paymentAmo
          : 0;
      break;
    case '194Q':
      fields = findRate(pan, recipient, 0.1, 0.1, 5);
      threshold = 5000000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194R':
    case '194R(proviso)':
      fields = findRate(pan, recipient, 10, 10, 20);
      threshold = 20000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case '194S':
    case '194S(proviso)':
      fields = findRate(pan, recipient, 1, 1, 20);
      threshold = 10000;
      if (paymentAmo > threshold) {
        res = fields.rate * paymentAmo;
      }
      break;
    case 'default':
      break;
  }
  let msgTDS =
    threshold === -1
      ? `Rule of TDS: For payment to the party during the F.Y. `
      : `Rule of TDS: If payment to the party during the F.Y. exceeds ₹${threshold} then TDS `;
  msgTDS += fields?.msgTDS;
  return {
    tds: Math.round(res),
    msgTDS: msgTDS,
    msgPAN: fields?.msgPAN,
  };
};
